export const day_month_year = ["Asia", "Africa", "Australia", "Europe"];
export const day_year_month = ["America", "Canada", "Philippines"];